import {bootstrapDangerGrowl as errorGrowl} from "@core/Util/growler";
import readableNumber from '@core/Util/format-number';

import {createNamespacedHelpers} from "vuex";

const {mapState, mapGetters, mapActions} = createNamespacedHelpers('audienceManager/builder');

const isAborted = (err) => {
    //https://stackoverflow.com/a/46785332
    return err instanceof Error && err.name === 'AbortError';
};

export default {
    name: "ProgressBar",
    created(){
        //TODO: 'OnLoaded'/'onReady'/'isReady' watcher or something of the like
        // this.loadProgress();
    },
    filters: {
        readableNumber
    },
    methods: mapActions({
        async loadProgress(dispatch){
            //We only want a single load to be happening at a time
            if(this.isLoading){
                return;
            }

            try {
                await dispatch('loadProgress');    
            } catch(err){
                if(isAborted(err)){
                    return;
                }

                errorGrowl(err);   
            }
        }
    }),
    computed: {
        ...mapState({
            isLoading: 'isLoadingAudienceProgress',
            audienceProgress: 'audienceProgress'
        }),
        ...mapGetters({
            lastRetrievedDisplay: 'audienceProgressLastRetrievedDisplay'
        }),
        
        /**
         * Current reached percentage of goal
         * @returns {number}
         */
        percentageTowardsGoal(){
            //If for some reason we exceed our goal; return 100%
            return Math.min(
                //Round value is required for our stylesheet
                Math.round(((this.audienceProgress.total || 0) / this.audienceProgress.goal) * 100),
                100
            );
        },
        hasGoalDefined(){
            return this.audienceProgress.goal !== undefined;
        },
        hasTotalDefined(){
            return this.audienceProgress.total != null;
        }
    }
};